<template>
  <div>
    <!-- 搜索表单 -->
    <search-form :formConfig="formConfig" :source="searchData" @search="search" @handleSearch="handleSearch">
      <template slot="btns" v-if="formBtns.indexOf('importBtn') > -1">
        <a-button @click="onImport" class="search-btn-item" type="primary">导入</a-button>
      </template>
      <template slot="btns" v-if="formBtns.indexOf('addContract') > -1">
        <a-button @click="addContract()" class="search-btn-item" type="primary"
          :disabled="selectedRowKeys.length == 0">匹配合同</a-button>
      </template>
      <template slot="btns" v-if="formBtns.indexOf('delContract') > -1">
        <a-button @click="delContract()" class="search-btn-item" type="primary"
          :disabled="selectedRowKeys.length == 0">解除合同</a-button>
      </template>
      <template slot="btns" v-if="formBtns.indexOf('addvoucher') > -1">
        <a-button @click="toDeliveryCreate('add')" class="search-btn-item" type="primary"
          :disabled="selectedRowKeys.length == 0">匹配附件</a-button>
      </template>
      <template slot="btns" v-if="formBtns.indexOf('revokeBtn') > -1">
        <a-button @click="cancel('撤销')" class="search-btn-item btn-red-line"
          :disabled="selectedRowKeys.length == 0">撤销</a-button>
      </template>
      <template slot="btns" v-if="formBtns.indexOf('applyBtn') > -1">
        <a-button class="search-btn-item" type="primary" :disabled="selectedRowKeys.length == 0"
          @click="systemCheck">平台查验</a-button>
      </template>
      <template slot="btns" v-if="formBtns.indexOf('applyUserBtn') > -1">
        <a-button class="search-btn-item" type="primary" :disabled="selectedRowKeys.length == 0"
          @click="selfCheck">自助查验</a-button>
      </template>
      <template slot="btns" v-if="formBtns.indexOf('deletBtn') > -1">
        <a-button @click="cancel('删除')" class="search-btn-item btn-red-line"
          :disabled="selectedRowKeys.length == 0">删除</a-button>
        <span class="text-color-orange"
          v-if="selectedRowKeys.length > 0 && formBtns.indexOf('applyBtn') > -1">温馨提示：若信息无误，自助查验仍不通过，可申请平台平台查验</span>
      </template>
    </search-form>

    <!-- 表格 -->
    <div class="table-common common common-scroll">
      <div class="table-check-bar" v-if="selectedRows.length">
        已选择：
        <span class="text-color-blue">{{ selectedRows.length }} 条</span>
        含税金额：
        <span class="text-color-orange">{{ totalPayable(selectedRows) | splitK }} 元</span>
      </div>
      <a-table size="middle" :columns="columns" :row-key="record => record.id" :data-source="tableData"
        :pagination="pagination" :loading="loading" @change="handleTableChange" bordered :locale="{ emptyText: '暂无数据' }"
        :row-selection="tableSelect" :scroll="{}">
        <template slot="cyCode" slot-scope="text, record">
          <div class="spceCenter">
            <div class="ellipsis" style="flex:1" :title="text">
              {{ text }}
            </div>
            <a-popover :title="'不通过原因-' +
              (record.checkType == 'auto' ? '自助查验' : '平台查验')
              ">
              <template slot="content">
                <div style="color:#666;max-width:200px;">
                  {{ record.resultMsg || "暂无原因" }}
                </div>
              </template>
              <svg v-if="record.resultCode == 2" class="payable-icon" aria-hidden="true">
                <use xlink:href="#gold-icon-tishi"></use>
              </svg>
            </a-popover>
          </div>
        </template>
        <template slot="invoiceType" slot-scope="text">
          {{ text | invoiceTypeFilter }}
        </template>
        <template slot="invoiceCode" slot-scope="text, record">
          <span v-if="record.invoiceCode">{{ record.invoiceCode }}</span>
          <span v-if="!record.invoiceCode">--</span>
        </template>
        <template slot="invoiceNumber" slot-scope="text, record">
          <a @click="toInvoiceInfo(record)">{{ text }}</a>
        </template>
        <template slot="billTime" slot-scope="text">
          {{ text | dateFormat("YYYY-mm-dd") }}
        </template>
        <template slot="invoiceAmount" slot-scope="text">
          {{ text | splitK }}
        </template>
        <template slot="invoiceAmountWithVat" slot-scope="text">
          {{ text | splitK }}
        </template>
        <template slot="checkType" slot-scope="text">
          {{ text | checkTypeFilter }}
        </template>
        <template slot="contractNo" slot-scope="text, record">
          <a v-if="text" @click="contractInfoOpen(record)">{{ text }}</a>
          <span v-else>--</span>
        </template>
        <template slot="useStatus" slot-scope="text">
          {{ text | dictFilter(dict.useStatusList) }}
        </template>
        <template slot="otherFile" slot-scope="text, record">
          <div>
            <div v-if="['UNMATCHED', 'UNUSED'].indexOf(record.useStatus) > -1">
              <a v-if="!record.uploaded" @click="toDeliveryCreate('add', record)">上传</a>
              <a v-else @click="toDeliveryCreate('edit', record)">编辑</a>
            </div>

            <a @click="toDeliveryCreate('detail', record)" v-else>查看</a>
          </div>
        </template>
        <template slot="operationEdit" slot-scope="text, record">
          <a @click="toInvoiceInfo(record)">查看</a>
          <a @click="toInvoiceEdit(record)">编辑</a>
        </template>
      </a-table>
      <div :class="{
        'table-total': pagination.total > 0,
        'table-total-none': pagination.total == 0
      }">
        共有记录：
        <span class="text-color-blue">{{ pagination.total }} 条</span>含税金额：
        <span class="text-color-orange">{{ totalPayable(tableData) | splitK }} 元</span>
      </div>
    </div>
    <!-- 查看弹窗 -->
    <invoiceInfo ref="invoiceInfo" :readonly="true" :info.sync="curRow" />
    <!-- 编辑弹窗 -->
    <invoiceInfo ref="invoiceEdit" :readonly="false" :info.sync="curRow" :btns="['save', 'close']" @save="successHandle"
      @check="successHandle" />
    <!-- 匹配合同 -->
    <contractDialog title="匹配合同" ref="contractEdit" :readonly="false" :selectedRows.sync="selectedRows"
      :btns="['save', 'close']" @save="contractSuccessHandle" />
    <!-- 查看合同 -->
    <contractDialog title="匹配合同详情" ref="contractInfo" :readonly="true" :info.sync="curRow" />
    <!-- 导入弹窗 -->
    <a-modal title="导入" v-model="modalShowImport" @ok="checkSeller" @cancel="closeImport" width="450px"
      :loading="importDialogLoad" destroyOnClose>
      <a-form-model ref="ruleFormImport" :model="importData" :label-col="{ span: 8 }" :wrapper-col="{ span: 13 }">
        <a-form-model-item label=" " prop="importType" :colon="false" style="margin-bottom:8px;">
          <a-radio-group name="importType" v-model="importData.importType">
            <a-radio v-for="item in importType" :value="item.value" :key="item.value">
              {{ item.name }}
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="买方名称" prop="importType" style="margin-bottom:8px;">
          <select-search v-show="importData.importType == 2" v-model="importData.tenantObj2" :searchSource="true"
            :dataSource="importTypeOption" headNameFirst="卖方名称" headNameSecond="社会信用代码" valuePorp="orgCode"
            labelPorp="userName" @handleChange="changeTenant" @handleSearch="handleSearchType"></select-search>
          <select-search v-show="importData.importType == 1" v-model="importData.tenantObj" :searchSource="true"
            :dataSource="importOption" headNameFirst="买方名称" headNameSecond="社会信用代码" valuePorp="cstOrgCode"
            labelPorp="cstNm" @handleChange="changeTenant" @handleSearch="handleSearchImport"></select-search>
        </a-form-model-item>
        <a-form-model-item label="买方社会信用代码" prop="importType" v-show="importData.importType == 1"
          style="margin-bottom:8px;">
          <a-input v-model="importData.tenantObj.key" disabled />
        </a-form-model-item>
        <a-form-model-item label=" " :colon="false" v-if="importData.importType == 2">
          <span class="text-color-red">{{ importErrText }}</span>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 相关附件 -->
    <relatedFileDialog ref="relatedFileDialog" @save="refresh()" />
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { selectSellerCst } from "@/api/rcvbBuy.js";
import { circleQuery } from "@/api/circle.js";
import { findGoldEstbOrRcPtyOrPypt } from "@/api/gold.js";
import {
  invoiceList,
  invDelete,
  go2Check,
  go2PlatFormCheck,
  selectSellerCstByName,
  deleteContractInfo
} from "@/api/payable.js";
import { mapActions } from "vuex";
import invoiceInfo from "./invoice-info-dialog";
import contractDialog from "./contract-info-dialog";
import confirmModal from "@/components/table-find-rcvb/confirm-modal";
import confirmPasswordModal from "@/components/table-find-rcvb/confirm-password-modal";
import relatedFileDialog from "@/pages/bill-manage/receivable/related-file-dialog";
export default {
  props: {
    columnsSource: {
      type: [Array],
      required: false,
      default: function () {
        return null;
      }
    },
    formSource: {
      type: [Array],
      required: false,
      default: function () {
        return null;
      }
    },
    // 页面的操作btns
    formBtns: {
      type: Array,
      default: function () {
        return [];
      }
    },
    // 查验结果查询
    resultCode: {
      type: [String, Number],
      required: false,
      default: function () {
        return 0;
      }
    }
  },
  components: {
    invoiceInfo,
    contractDialog,
    confirmModal,
    confirmPasswordModal,
    relatedFileDialog
  },
  name: "payableComponent",
  data() {
    return {
      searchData: {
        cyCode: undefined,
        buryOrgCode: {},
        invoiceType: [],
        invoiceCode: undefined,
        invoiceNumber: undefined,
        billTime: [],
        checkType: [],
        contractNo: undefined,
        useStatus: []
      },
      formConfig: [
        {
          prop: "buryOrgCode",
          type: "selectSearch",
          label: "买方名称",
          option: [],
          searchSource: true,
          headNameFirst: "买方名称",
          headNameSecond: "社会信用代码",
          valuePorp: "orgCode",
          labelPorp: "cstNm",
          searchHandle: "handleSearch"
        },
        {
          prop: "cyCode",
          type: "input",
          label: "查验编号"
        },
        {
          prop: "invoiceType",
          type: "select",
          label: "发票类型",
          mode: 'multiple',
          option: this.dict.invType,
          defaultProps: {
            value: "dctVal",
            label: "dctValNm"
          }
        },
        {
          prop: "invoiceCode",
          type: "input",
          label: "发票代码"
        },
        {
          prop: "invoiceNumber",
          type: "input",
          label: "发票号码"
        },
        {
          prop: "billTime",
          type: "dateRange",
          label: "开票日期"
        },
        {
          prop: "checkType",
          type: "select",
          label: "查验方式",
          mode: 'multiple',
          option: [],
          defaultProps: {
            value: "dctVal",
            label: "dctValNm"
          }
        },
        {
          prop: "contractNo",
          type: "input",
          label: "合同编号"
        },
        {
          prop: "useStatus",
          type: "select",
          label: "使用状态",
          option: this.dict.useStatusList,
          mode: "multiple",
          defaultProps: {
            value: "value",
            label: "name"
          }
        }
      ],
      columns: [
        {
          title: "查验编号",
          dataIndex: "cyCode",
          sorter: true,
          width: 180,
          scopedSlots: { customRender: "cyCode" }
        },
        {
          title: "买方名称",
          dataIndex: "buryName",
          width: 140,
          ellipsis: true,
          sorter: true
        },
        {
          title: "发票类型",
          dataIndex: "invoiceType",
          scopedSlots: { customRender: "invoiceType" },
          width: 90
        },
        {
          title: "发票代码",
          dataIndex: "invoiceCode",
          scopedSlots: { customRender: "invoiceCode" },
          sorter: true,
          width: 90
        },
        {
          title: "发票号码",
          sorter: true,
          dataIndex: "invoiceNumber",
          scopedSlots: { customRender: "invoiceNumber" },
          width: 120
        },
        {
          title: "开票日期",
          dataIndex: "billTime",
          sorter: true,
          scopedSlots: { customRender: "billTime" },
          width: 120
        },
        {
          title: "不含税金额(元)",
          dataIndex: "invoiceAmount",
          scopedSlots: { customRender: "invoiceAmount" },
          width: 120
        },
        {
          title: "含税金额(元)",
          sorter: true,
          dataIndex: "invoiceAmountWithVat",
          scopedSlots: { customRender: "invoiceAmountWithVat" },
          width: 120
        },
        {
          title: "查验方式",
          dataIndex: "checkType",
          scopedSlots: { customRender: "checkType" },
          width: 100
        },
        {
          title: "合同编号",
          dataIndex: "contractNo",
          scopedSlots: { customRender: "contractNo" },
          width: 180
        },
        {
          title: "相关附件",
          dataIndex: "otherFile",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "otherFile" }
        },
        {
          title: "使用状态",
          dataIndex: "useStatus",
          width: 100,
          scopedSlots: { customRender: "useStatus" }
        },
        {
          title: "操作",
          width: 100,
          dataIndex: "operationEdit",
          scopedSlots: { customRender: "operationEdit" }
        }
      ],
      tableData: [],
      pagination: {
        pageSize: 10,
        current: 1,
        sortField: "cyCode",
        sortOrder: "descend",
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ["5", "10", "20", "50", "100"],
        showTotal: total => {
          return `共 ${total} 条`;
        }
      },
      loading: false,
      selectedRows: [],
      selectedRowKeys: [],
      //  导入弹窗
      importData: {
        importType: "1",
        tenantName2: undefined, //键入值
        tenantObj: {},
         tenantObj2: {
           cstNm: '',
        cstOrgCode:  '',
        guaranteeCstId:  '',
        }
      },
      modalShowImport: false,
      importType: [
        { name: "圈子", value: "1" },
        { name: "键入", value: "2" }
      ],
      importOption: [],
      importTypeOption: [],
      importDialogLoad: false,
      importErrText: "",
      curRow: {} //查看、编辑当前row
    };
  },
  computed: {
    ...mapGetters({
      userObj: "home/getUserObj"
    }),
    tableSelect() {
      return {
        type: "checkbox",
        selectedRowKeys: this.selectedRowKeys,
        selectedRows: this.selectedRows,
        onChange: this.onTableChange,
        getCheckboxProps: record => ({
          props: {
            disabled: ["LOCKED", "INUSE", "USED"].indexOf(record.useStatus) > -1 // 已锁定、使用中、已使用不能操作
          }
        })
      };
    }
  },
  created() {
    this.initPage();

    this.getDicAsync("CheckMod").then(res => {
      let index = this.formConfig.findIndex(i => i.prop == "checkType");
      if (this.formConfig[index]) {
        this.formConfig[index].option = res || [];
      }
    });
    this.getDicAsync("InvoiceType").then(res => {
      let index = this.formConfig.findIndex(i => i.prop == "invoiceType");
      if (this.formConfig[index]) {
        this.formConfig[index].option = res || [];
      }
    });

    this.getTableData();
  },
  methods: {
    ...mapActions({
      getDicAsync: "app/getDicAsync"
    }),
    // 过滤搜索表单、表格表头展示
    initPage() {
      if (this.columnsSource) {
        let resColumn = [];
        this.columnsSource.forEach(item => {
          for (let i = 0; i < this.columns.length; i++) {
            if (this.columns[i].title == item) {
              resColumn.push({
                ...this.columns[i],
                title: this.columns[i].title2 || this.columns[i].title //针对不用的操作列表，title为区分字段，title2为显示字段
              });
              break;
            }
          }
        });
        this.columns = resColumn;
      }
      if (this.formSource) {
        let resForm = [];
        this.formSource.forEach(item => {
          for (let i = 0; i < this.formConfig.length; i++) {
            if (this.formConfig[i].prop == item) {
              resForm.push(this.formConfig[i]);
              break;
            }
          }
        });
        this.formConfig = resForm;
      }
    },
    // 买方名称选项
    handleSearch(value, data) {
      const cstIds = this.userObj.cstIds.join(",");
      findGoldEstbOrRcPtyOrPypt({
        cstNm: value,
        pageNum: 1,
        pageSize: 10,
        queryType: 2,
        rcPty: cstIds,
        cstIds: cstIds
      })
        .then(res => {
          this.formConfig.forEach((item, index) => {
            if (item.label == "买方名称") {
              this.formConfig[index].option = res.data.grid.list;
              this.importOption = res.data.grid.list;
            }
          });
        })
        .catch(error => {
          console.log(error);
        });

      // selectSellerCst({
      //   pageSize: 10,
      //   effStCd: 1,
      //   statusCode: 0,
      //   state: 2,
      //   userName: value || "",
      //   pageNum: 1
      // })
      //   .then(res => {
      //     this.formConfig.forEach((item, index) => {
      //       if (item.label == "买方名称") {
      //         this.formConfig[index].option = res.data.grid.list;
      //         this.importOption = res.data.grid.list;
      //       }
      //     });
      //   })
      //   .catch(error => {
      //     console.log(error);
      //   });
    },
    // 导入弹窗选择卖方名称
    handleSearchImport(value, data) {
      circleQuery({
        tab: 2,
        pageSize: 10,
        pageNum: 1
      })
        .then(res => {
          this.importOption = res.data.grid.list;
        })
        .catch(error => {
          console.log(error);
        });
    },
     // 键入搜索
    handleSearchType(value, data) {
       selectSellerCstByName({ userName: value })
          .then(res => {
           this.importTypeOption = res.data.grid.list;
          })
          .catch(err => {
            
          });
    },
    // 查询重置
    search(data, cfg) {
      this.searchData = data || this.searchData;
      this.getTableData();
    },
    //表格排序回调
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.pagination.sortField = sorter.field || pagination.sortField;
      this.pagination.sortOrder = sorter.order || pagination.sortOrder;
      this.pagination.total = this.pagination.total || 0;
      this.getTableData();
    },
    getTableData() {
      let params = {};
      params = {
        useCase: "supplier", //查验类型 核心企业导入-融资-供应商导入应收：receivable-financing-supplier
        resultCode: this.resultCode,
        orderBy: this.pagination.sortField
          ? `${this.pagination.sortField == "buryName" ? "buryOrgCode" : this.pagination.sortField} ${this.pagination.sortOrder == "ascend" ? "asc" : "desc"
          },sortFlag asc`
          : "",
        cyCode: this.searchData.cyCode,
        buryOrgCode:
          this.searchData.buryOrgCode && this.searchData.buryOrgCode.key,
        invoiceType: this.searchData.invoiceType,
        invoiceCode: this.searchData.invoiceCode,
        invoiceNumber: this.searchData.invoiceNumber,
        billTimeStart: this.searchData.billTime[0],
        billTimeEnd: this.searchData.billTime[1],
        checkType: (this.searchData.checkType && this.searchData.checkType.length > 0) ? this.searchData.checkType.map(item => typeof item === 'object' ? item.dctVal : item).join(',') : null,
        contractNo: this.searchData.contractNo,
        useStatus: this.searchData.useStatus && this.searchData.useStatus.length > 0 ? this.searchData.useStatus : null,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      };

      this.loading = true;
      invoiceList(params)
        .then(res => {
          this.pagination.total = res.data.grid.total;
          let list = res.data.grid.list;
          this.tableData = list;
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    },
    //表格选择回调
    onTableChange(selectedRows, data) {
      this.selectedRowKeys = selectedRows;
      this.selectedRows = this.tableData.filter(
        item => selectedRows.indexOf(item.id) > -1
      );
    },
    // 计算表格勾选合计
    totalPayable(list) {
      return list.reduce((acc, rec) => {
        return acc + (+rec["invoiceAmountWithVat"] || 0);
      }, 0);
    },
    // 查看发票
    toInvoiceInfo(record) {
      this.curRow = record;
      this.$refs.invoiceInfo.open();
    },
    // 编辑发票
    toInvoiceEdit(record) {
      this.curRow = record;
      this.$refs.invoiceEdit.open();
    },
    // 撤销
    cancel(text) {
      let self = this;
      this.$confirm({
        title: "撤销",
        content: "是否" + text + "所勾选的记录？",
        onOk() {
          const params = {
            ids: self.selectedRowKeys.join(",")
          };
          invDelete(params).then(res => {
            self.$message.success(text + "成功");
            self.selectedRowKeys = [];
            self.selectedRows = [];
            self.search();
          });
        },
        onCancel() { }
      });
    },
    // 打开导入弹窗
    onImport() {
      this.modalShowImport = true;
    },
    // 关闭导入弹窗
    closeImport() {
      this.modalShowImport = false;
      this.importData.importType = "1";
      this.importData.tenantNode = null;
      this.importData.tenantObj = {};
      this.importData.tenantName2 = undefined;
    },
    // 卖方选项变化
    changeTenant(data, node) {
      this.importData.tenantNode = node;
    },
    // 校验导入弹窗条件
    checkSeller() {
      if (this.importData.importType == "1") {
        if (
          !this.importData.tenantNode ||
          (this.importData.tenantNode && !this.importData.tenantNode.cstNm)
        ) {
          this.$message.error("请填写买方名称");
          return;
        }
        this.importOk();
      }
      if (this.importData.importType == "2") {
        if (
          !this.importData.tenantNode ||
          (this.importData.tenantNode && !this.importData.tenantNode.userName)
        ) {
          this.$message.error("请填写卖方名称");
          return;
        }
        this.importOk();
        // if (!this.importData.tenantName2) {
        //   this.$message.error("请填写买方名称");
        //   return;
        // }
        // this.importDialogLoad = true;
        // selectSellerCstByName({ userName: this.importData.tenantName2 })
        //   .then(res => {
        //     let list = res.data.grid.list || [];
        //     if (list[0]) {
        //       this.importData.tenantNode = {
        //         cstNm: list[0].userName,
        //         cstOrgCode: list[0].orgCode,
        //         tenantId: list[0].tenantId
        //       };
        //       this.importDialogLoad = false;
        //       this.importOk();
        //     }
        //   })
        //   .catch(err => {
        //     console.log(err);
        //     this.importDialogLoad = false;
        //     this.importErrText = err.description;
        //   });
      }
    },
    // 去导入
    importOk() {
      let strName = this.importData.tenantNode && this.importData.tenantNode.cstNm
      let tenanId = this.importData.tenantNode && this.importData.tenantNode.tenantId
      let sellrOrgCode = this.importData.tenantNode && this.importData.tenantNode.cstOrgCode
      if(this.importData.importType == 2){
        strName = this.importData.tenantNode && this.importData.tenantNode.userName
        tenanId = this.importData.tenantNode && this.importData.tenantNode.tenanId
        sellrOrgCode = this.importData.tenantNode && this.importData.tenantNode.orgCode
      }
      this.MENUAPI.goToOneTab({
        path: "bill-manage/receivable-import",
        query: {
          tenanId:tenanId,
          buryName:strName,
          buryOrgCode:sellrOrgCode
        },
        noMenu: true
      });
      this.closeImport();
    },
    selfCheck() {
      let self = this;
      this.$confirm({
        title: "自助查验",
        content: "是否发起自助查验？",
        onOk() {
          let params = {
            cyCodeList: self.selectedRows.map(i => i.cyCode)
          };
          go2Check(params, "loading").then(res => {
            self.$message.success("操作成功");
            self.refresh();
          });
        },
        onCancel() { }
      });
    },
    systemCheck() {
      let self = this;
      this.$confirm({
        title: "平台查验",
        content: "是否发起平台查验？",
        onOk() {
          let params = {
            cyCodeList: self.selectedRows.map(i => i.cyCode)
          };
          go2PlatFormCheck(params, "loading").then(res => {
            self.$message.success("操作成功");
            self.refresh();
          });
        },
        onCancel() { }
      });
    },
    // 匹配合同
    addContract() {
      let item = this.selectedRows[0] || {};
      let diffItem = this.selectedRows.find(i => i.buryName != item.buryName);
      if (diffItem) {
        this.$message.warn("勾选记录的买方名称需一致");
        return;
      }
      let contractItem = this.selectedRows.find(i => i.contractNo);
      if (contractItem) {
        this.$message.warn("勾选记录中存在已匹配合同的记录");
        return;
      }
      this.$refs.contractEdit.open();
    },
    // 匹配合同成功回调
    contractSuccessHandle() {
      this.refresh();
    },
    // 解除匹配
    delContract() {
      let contractItem = this.selectedRows.find(i => !i.contractNo);
      if (contractItem) {
        this.$message.warn("勾选记录中存在未匹配合同的记录");
        return;
      }
      let contractNo = this.selectedRows[0].contractNo;
      let contractNoFlag = this.selectedRows.find(
        i => i.contractNo != contractNo
      );
      if (contractNoFlag) {
        this.$message.warn("勾选记录合同编号不一致");
        return;
      }

      let self = this;
      this.$confirm({
        title: "解除匹配",
        content: "是否解除所勾选记录的合同匹配？",
        onOk() {
          let params = {
            orgCode: self.selectedRows[0].buryOrgCode,
            ids: self.selectedRows.map(i => i.id),
            contractNo: self.selectedRows[0].contractNo
          };
          deleteContractInfo(params, "loading").then(res => {
            self.$message.success("解除成功");
            self.refresh();
          });
        },
        onCancel() { }
      });
    },
    // 编辑成功回调
    successHandle() {
      this.refresh();
    },
    contractInfoOpen(data) {
      this.curRow = data;
      this.$refs.contractInfo.open();
    },
    modalOk(data) {
      this.confirmModalData = this.utils.deepClone(data);
      this.modalShowPwd = true;
    },
    modalOkPwd() {
      this.modalCancel();
    },
    modalCancel(e) {
      this.$refs.modalGoldOpen && this.$refs.modalGoldOpen.close();
      this.modalShowPwd = false;
      this.confirmModalData = null;
      this.refresh();
    },
    // 相关附件上传、编辑、查看
    toDeliveryCreate(dialogType, record) {
      let invDataList = record ? [record] : this.selectedRows;
      for (let i = 0; i < invDataList.length; i++) {
        if (invDataList.length > 1 && invDataList[0].buryOrgCode != invDataList[i].buryOrgCode) {
          this.$message.warn("买方不同，无法进行批量操作");
          return;
        }

        if (invDataList.length > 1 && invDataList[i].uploaded) {
          this.$message.warn("勾选记录存在相关附件，无法进行批量操作");
          return;
        }
        else if (invDataList.length == 1 && invDataList[i].uploaded) {
          dialogType = "edit";
        }

      }

      this.$refs.relatedFileDialog.open({
        invData: record || invDataList[0],
        invDataList: invDataList,
        dialogType: dialogType
      });
    },
    // 页面刷新方法
    refresh() {
      this.importData = {
        importType: "1",
        tenantObj: {}
      };
      this.selectedRows = [];
      this.selectedRowKeys = [];
      this.search();
    }
  }
};
</script>
<style scoped>
.payable-icon {
  width: 17px;
  height: 17px;
  margin-left: 4px;
  position: absolute;
  right: 0;
  top: 7px;
}

.common-question {
  color: #ccc;
  font-size: 13px;
  margin-right: 10px;
}

.text-center {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/bill-manage/receivable/list.vue